<template lang="">
  <div class="div1">
   <ToastPrime />
     <div class="container">
       <h2>{{ $t("userDataTitle") }}</h2>
       <div class="table-display">
        <div class="cell-display div2">
          <div class="card">
            <div class="formgrid grid">
             <div class="field col-12 md:col-4 text-left">
               <label for="userName">{{ $t("userName") }} (*)</label>
               <input
                 id="userName"
                 v-model="userName"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="userLastName">{{ $t("userLastName") }} (*)</label>
               <input
                 id="userLastName"
                 v-model="userLastName"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="userDNI">{{ $t("userDNI") }}</label>
               <input
                 id="userDNI"
                 v-model="userDNI"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-12 p-2"></div>
             <div class="field col-12 md:col-4 text-left">
               <label for="userCompany">{{ $t("userCompany") }} (*)</label>
               <input
                 id="userCompany"
                 v-model="userCompany"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="userCIF">{{ $t("userCIF") }}</label>
               <input
                 id="userCIF"
                 v-model="userCIF"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
 
            </div>
          </div>
         </div>
        </div>
     </div>
 
     <div class="container">
       <h2>{{ $t("shipDataTitle") }}</h2>
       <div class="table-display">
        <div class="cell-display div2">
          <div class="card">
            <div class="formgrid grid">
             <div class="field col-12 md:col-4 text-left">
               <label for="shipName">{{ $t("shipName") }} (*)</label>
               <input
                 id="shipName"
                 v-model="name"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="shipIMO">{{ $t("imoNumber") }} (*)</label>
               <input
                 id="shipIMO"
                 v-model="imo"
                 type="text"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <p for="state">{{ $t("shipType") }} (*)</p>
               <DropdownPrime
                 id="state"
                 v-model="shipTypeSelected"
                 :options="shipTypes"
                 optionLabel="name"
                 class="field col-12 md:col-12"
               />
             </div>
             <div class="field col-12 md:col-12 p-2"></div>
             <div class="field col-12 md:col-4 text-left">
               <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn) (*)</label>
               <input
                 id="shipTotalDistance"
                 v-model="totalDistance"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
               <input
                 id="shipGT"
                 v-model="gt"
                 v-tooltip.top="$t('tooltipGT')"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t) (*)</label>
               <input
                 id="shipDWT"
                 v-model="dwt"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-12 p-2"></div>
             <div class="field col-12 md:col-4 text-left">
               <label for="dateformat">{{ $t("dateKeelLaid") }}</label>
               <CalendarPrime
                 id="dateformat"
                 @input="formatDate()"
                 @date-select="formatDate()"
                 v-model="firstdate"
                 dateFormat="yy/mm/dd"
                 class="surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="dateformat">{{ $t("dateSigning") }}</label>
               <CalendarPrime
                 id="dateformat"
                 @input="formatDate()"
                 @date-select="formatDate()"
                 v-model="seconddate"
                 dateFormat="yy/mm/dd"
                 class="surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="dateformat">{{ $t("dataDelivery") }}</label>
               <CalendarPrime
                 id="dateformat"
                 @input="formatDate()"
                 @date-select="formatDate()"
                 v-model="thirddate"
                 dateFormat="yy/mm/dd"
                 class="surface-overlay border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-12 p-2"></div>
 
             <div class="field col-12 md:col-4 text-left">
               <p for="iceClassElement">{{ $t("questionShipIce") }} (*)</p>
               <DropdownPrime
                 id="iceClassElement"
                 v-model="iceClassTypeSelected"
                 :options="iceClassTypeOptions"
                 optionLabel="name"
                 class="field col-12 md:col-12"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="firstname6" class="right">{{ $t("lengthOverall") }} - <strong>LOA</strong> (m)</label>
               <input
                 id="firstname6"
                 v-model="loa"
                 v-tooltip.top="$t('tooltipOthers')"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="lastname6">{{ $t("lengthbtwPerpendicular") }} - <strong>LPP</strong> (m)</label>
               <input
                 id="lastname6"
                 v-model="lpp"
                 v-tooltip.top="$t('tooltipOthers')"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-12 p-2"></div>
             <div class="field col-12 md:col-4 text-left">
               <label for="firstname6"
                 >{{ $t("displacementVolume") }} - <strong>V<sub>d</sub></strong> (m&sup3;)</label
               >
               <input
                 v-model="displacementVolume"
                 v-tooltip.top="$t('tooltipVd')"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="firstname6" class="right"
                 >{{ $t("summerLoad") }} - <strong>d<sub>s</sub></strong> (m)</label
               >
               <input
                 id="firstname6"
                 v-model="ds"
                 v-tooltip.top="$t('tooltipOthers')"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <div class="field col-12 md:col-4 text-left">
               <label for="lastname6"
                 >{{ $t("breadth") }} - <strong>B<sub>s</sub></strong> (m)</label
               >
               <input
                 id="lastname6"
                 v-model="bs"
                 v-tooltip.top="$t('tooltipOthers')"
                 type="number"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               />
             </div>
             <!--Estos párrafos son de prueba para ver que se peude 'scrollear' por la pantalla-->
             <div class="field col-12 md:col-12 p-2"></div>
             <div class="field col-12 md:col-12 p-2"></div>
   
 
            </div>
 
            <p style="padding-right: 80%;"><strong>{{ $t("warningObligatory") }}</strong></p>
            <div class="field col-12 md:col-12 p-2"></div>
 
            <FuelInputConsumptionTable :fuelArray = "fuelConsumptionArray" @obtener-lista-fuel="getFuelList"></FuelInputConsumptionTable>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>
 
            <p style="padding-right: 90%;"><strong>(*) {{ $t("requiredFields") }}</strong></p>
 
            <div class="field col-12 md:col-12 p-2"></div>
 
            <!-- Cuadro del EEXI preescrito antiguo -->
            <div class="formgrid grid CII_paragraph">
 
               <p> {{ $t("oldRewrittenCII") }} (gCO&#8322;/t·mn): </p>
               <div class="field col-12 md:col-12 p-2"></div>
               <li v-for="(year, index) in this.oldCIIYears" :key="index" style="width:200px">
                 &ensp; {{ year.year }} &nbsp; <p class="CII_value">  {{year.value}} </p> &emsp;
               </li>
 
               <div class="field col-12 md:col-12 p-2"></div>
               <div class="field col-12 md:col-12 p-2"></div>
 
               <p class="right"> {{ $t("oldAttainedCII") }} (gCO&#8322;/t·mn): </p>
               <div class="field col-12 md:col-12 p-2"></div>
               <p id="oldAttainedCII"> {{this.oldAttainedCII}}</p>
 
               <div class="field col-12 md:col-12 p-2"></div>
 
               <div>
                 <strong>{{ $t("warningCII") }}</strong>
                 <div style="display:inline; padding-left: 700px;">
                   <ButtonPrime @click="calcOldPrewrittenCII()" id="add-button">{{ $t("calcOldPCII") }}</ButtonPrime> &ensp;
                   <ButtonPrime @click="calcOldAttainedCII()"  id="add-button">{{ $t("calcOldACII") }}</ButtonPrime>
                 </div>
               </div>
 
            </div>
          </div>
        </div>
       </div>
 
       
     </div>
 
     <div style="padding-left: 60%;">
       <ButtonPrime @click="save()" id="add-button">{{ $t("save") }}</ButtonPrime>
       &ensp; &ensp; &ensp; &ensp;
       <ButtonPrime @click="cancel()" id="add-button">{{ $t("cancel") }}</ButtonPrime>
     </div>
 
     <!--Estos párrafos son de prueba para ver que se puede 'scrollear' por la pantalla-->
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
     <div class="field col-12 md:col-12 p-2"></div>
 
  </div>
 </template>
 
 <script>
 import router from "@/router/index";
 import store from "@/store/index";
 import utils from "@/utils/configuration/config.js";
 import ShipService from "@/services/ShipService";
 import ShipTypeService from "@/services/ShipTypeService";
 import FuelTypeService from "@/services/FuelTypeService";
 import UserService from "@/services/UserService";
 import ParametricTableService from "@/services/ParametricTableService";
 import useVuelidate from "@vuelidate/core";
 import { required } from "@vuelidate/validators";
 import { ToastSeverity } from "primevue/api";
 
 import FuelInputConsumptionTable from "./FuelInputConsumptionTable.vue"
 import NeobuqCarbonService from "@/services/Neobuq/NeobuqCarbonService";
 
 export default {
 
   components: {
     FuelInputConsumptionTable
   },
   
   setup() {
     return { v$: useVuelidate() };
   },
   data(){
     return{
         
         //datos del usuario
         user : store.getters.currentUser,
         userName : store.getters.currentUser.firstName,
         userLastName : store.getters.currentUser.lastName,
         userCompany : store.getters.currentUser.company,
         userDNI : store.getters.currentUser.dni,
         userCIF : store.getters.currentUser.cif,
         userUid : store.getters.currentUser.uid,
         userSector : store.getters.currentUser.sector,
         userCharge : store.getters.currentUser.charge,
         userEmail : store.getters.currentUser.email,
         userNameEmail : store.getters.currentUser.name,
 
         //datos del buque
         ship: store.getters.currentShip,
         name: store.getters.currentShip.name,
         imo: store.getters.currentShip.imo,
         gt: store.getters.currentShip.gt,
         dwt: store.getters.currentShip.dwt,
         displacementVolume: store.getters.currentShip.displacementVolume,
         loa: store.getters.currentShip.loa,
         lpp: store.getters.currentShip.lpp,
         ds: store.getters.currentShip.ds,
         bs: store.getters.currentShip.bs,
         totalDistance : store.getters.currentShip.totalDistance,
 
         iceClassTypeOptions: [],
         iceClassTypeSelected: { id: "", name: "" },
         shipTypes: [],
         shipTypeSelected: { id: "", name: "" },
         firstdate: null,
         seconddate: null,
         thirddate: null,
 
         fuelConsumptionArrayAux : store.getters.currentShip.fuelConsumption,
         fuelConsumptionArray: [],
 
         oldCIIYears: [{year: "2023", value: 0},{year: "2024", value: 0},{year: "2025", value: 0},{year: "2026", value: 0},
                       {year: "2027", value: 0},{year: "2028", value: 0},{year: "2029", value: 0},{year: "2030", value: 0}],
         oldAttainedCII: 0,
 
         isNEOBUQ : store.getters.currentShip.isNEOBUQ,
 
     }
   },
   
   validations() {
     return{
       //REVISAR LOS VALIDATORS
       imo: { required },
       name: { required }, 
       shipType: { required },
       totalDistance : { required },
       dwt: { required },
       iceClassTypeSelected : {required},
 
       userName : { required },
       userLastName : { required },
       userCompany : { required },
       //gt: { required },
       //loa: { required },
       //lpp: { required },
       //ds: { required },
       //bs: { required },
       //displacementVolume: { required },
     }
   },
   created(){
     this.shipService = ShipService.getInstance();
     this.shipTypeService = ShipTypeService.getInstance();
     this.shipTypeService.getTypes(this.shipTypes);
     this.userService = UserService.getInstance();
     this.carbonService = NeobuqCarbonService.getInstance();
     ParametricTableService.getInstance().getParametricTable(utils.config.firebaseConfig.parametricVersion);
     this.iceClassTypeSelected = this.ship.iceClassType;
 
     if (this.ship && this.ship.shipType) {
       const objForWindow = {
         id: this.ship.shipType.id,
         name: this.ship.shipType.name,
       };
       this.shipTypeSelected = objForWindow;
     }
 
     // Formateo de las fechas para el componente
     this.firstdate = this.getDateToComponent(this.ship.keelLaidDownDate);
     this.seconddate = this.getDateToComponent(this.ship.contractSignInDate);
     this.thirddate = this.getDateToComponent(this.ship.shipDeliveredDate);
 
     if(this.fuelConsumptionArrayAux == undefined || this.fuelConsumptionArrayAux == null){
       //console.log("no existe")
       this.fuelConsumptionArray.push({fuel: " ", consumption: 0})
 
     }else{
       //console.log("sí existe")
       for(let i = 0; i<this.fuelConsumptionArrayAux.length; i++){
         //console.log("Fuel Consumption Array Aux " + this.fuelConsumptionArrayAux[i].fuel.id)
         this.fuelConsumptionArray.push(this.fuelConsumptionArrayAux[i])
         //console.log("Fuel Consumption Array " + this.fuelConsumptionArray[i].fuel.id)
       }
     }
 
     //oldCIIYears
     if(this.ship.anualPrewrittenCII){
       this.oldCIIYears = this.ship.anualPrewrittenCII
     }
 
     //console.log("odlAttainedCII: " + this.ship.oldAttainedCII)
     if(this.ship.oldAttainedCII){
       this.oldAttainedCII = this.ship.oldAttainedCII
       //console.log("El tipo de odlAttainedCII es de: " + typeof(this.oldAttainedCII))
       this.oldAttainedCII = this.oldAttainedCII.toFixed(2)
     }
 
       
   },
 
   mounted() {
     const parametricTables = ParametricTableService.getInstance().getParametricTable(
       utils.config.firebaseConfig.parametricVersion
     );
     //console.log("parametricTables", parametricTables);
     this.iceClassTypeOptions = parametricTables.iceClassType;
     //console.log("Cargados los tipos de hielo");
   },
 
   methods:{
 
     formatDate() {
       //this.applyChangesToShip();
       this.EEDI = this.shipService.calcIsEEDIUsingDates(this.ship);
       //console.log("Han cambiado las fechas. IsEEDI = ", this.EEDI);
 
       this.$toast.add({
         severity: ToastSeverity.INFO,
         closable: false,
         summary: "Cambio de fechas. " + (this.EEDI ? " ¡¡ IS EEDI !!" : " NO EEDI"),
         life: 1000,
       });
     },
 
     getDateToComponent(dateFromFirebase) {
       return dateFromFirebase;
     },
 
     applyChangesToUser(){
 
       //aplicamos los datos al usuario
       this.user.firstName = this.userName;
       this.user.lastName = this.userLastName;
       this.user.company = this.userCompany;
       this.user.dni = this.userDNI;
       this.user.cif = this.userCIF;
       this.user.charge = this.userCharge;
       this.user.email = this.userEmail;
       this.user.sector = this.userSector;
       this.user.uid = this.userUid;
       this.user.name = "";
     },
 
     applyChangesToShip(){
       //poner alguna opción por si no metes nada, o un aviso con un toast
       this.ship.isNEOBUQ = true;
       this.ship.name = this.name;
       this.ship.imo = this.imo;
       ShipTypeService.AddShipTypeToShip(this.shipTypeSelected.id, this.ship);
       this.ship.totalDistance = this.totalDistance;
       this.ship.gt = this.gt;
       this.ship.dwt = this.dwt;
       this.ship.keelLaidDownDate = this.firstdate;
       this.ship.contractSignInDate = this.seconddate;
       this.ship.shipDeliveredDate = this.thirddate;
       this.ship.displacementVolume = this.displacementVolume;
       this.ship.loa = this.loa;
       this.ship.lpp = this.lpp;
       this.ship.ds = this.ds;
       this.ship.bs = this.bs;
       this.ship.iceClassType = this.iceClassTypeSelected;
       
       if(this.ship.oldPrewrittenCII == undefined){
         this.ship.oldPrewrittenCII = {}
       }
 
       if(this.ship.fuelConsumption == undefined || this.ship.fuelConsumption == null || this.ship.fuelConsumption.length > 0){
         this.ship.fuelConsumption = []
         //console.log("Estaba vacío")
       }
 
       //usar una constante para el tamaño, que si no entra en un bucle infinito porque va aumentando el tamaño del array
       const arrayLength = this.fuelConsumptionArray.length
       for(let k=0; k < arrayLength; k++){
         FuelTypeService.AddFuelTypeToShip(this.fuelConsumptionArray[k].fuel.id, this.fuelConsumptionArray[k].consumption, this.ship)
       }
     },
 
     //ESTO SOLO APLICA PARA LOS 9 PRINCIPALES DEL CII ANTIGUO, SI NO HAY NINGUNO EN LA LISTA, NO HACERLO
     calcOldPrewrittenCII(){
 
       var do_old_cii = false
       //console.log("Calculando el antiguo CII anual preescrito...")
       this.applyChangesToShip()
 
       //comprobamos los tipos de combustible del buque y vemos con cuales podemos comprobar el CII
       for(let i=0; i < this.ship.fuelConsumption.length; i++){
 
         //si al menos uno de los combustibles se usa para cii, hacemos el CII
         if(this.ship.fuelConsumption[i].fuel.for_cii){
           do_old_cii = true
         }
       }
 
       if(do_old_cii){
         //console.log("Hacemos el CII preescrito!")
         //lo calculamos para cada año
         const list_prewritten_CIIs = this.carbonService.calc_anual_prewritten_CII(this.ship)
 
         //los mostramos y guardamos los valores en su variable de 'ship'
         let numAux = 23
         let strNumAux = "20" + numAux
 
         for(let i=0; i<this.oldCIIYears.length; i++){
           this.oldCIIYears[i].value = list_prewritten_CIIs[i].toFixed(2)
           strNumAux = "20" + numAux
           this.ship.oldPrewrittenCII[strNumAux] = this.oldCIIYears[i].value
           numAux++;
         }
       }else{
         //poner un anuncio de que solo podemos calcular esto si tenemos al menos 1 combustible de CII antiguo
         this.$toast.add({
           severity: ToastSeverity.ERROR,
           closable: false,
           summary: "¡ERROR: No se puede calcular el CII antiguo si ninguno de los combustibles es el adecuado!",
           life: 1000,
         });
 
         //volvemos a poner los valores a 0 para mostrar que los hemos reseteado 
         let numAux = 23
         let strNumAux = "20" + numAux
         for(let i=0; i<this.oldCIIYears.length; i++){
           this.oldCIIYears[i].value = 0
           strNumAux = "20" + numAux
           this.ship.oldPrewrittenCII[strNumAux] = this.oldCIIYears[i].value
           numAux++;
         }
       }
     },
 
 
     calcOldAttainedCII(){
       //console.log("Calculando el antiguo CII obtenido...")
       var do_old_cii = false
       this.applyChangesToShip()
 
       //comprobamos los tipos de combustible del buque y vemos con cuales podemos comprobar el CII
       for(let i=0; i < this.ship.fuelConsumption.length; i++){
 
         //si al menos uno de los combustibles se usa para cii, hacemos el CII
         if(this.ship.fuelConsumption[i].fuel.for_cii){
           do_old_cii = true
         }
       }
 
       if(do_old_cii){
         //console.log("Hacemos el CII obtenido!")
         //comprobamos los tipos de combustible del buque y vemos con cuales podemos comprobar el CII
         const old_attained_CII = this.carbonService.calc_old_attained_CII(this.ship)
         this.oldAttainedCII = old_attained_CII.toFixed(2)
         this.ship.oldAttainedCII = this.oldAttainedCII
       }else{
         //poner un anuncio de que solo podemos calcular esto si tenemos al menos 1 combustible de CII antiguo
         this.$toast.add({
           severity: ToastSeverity.ERROR,
           closable: false,
           summary: "¡ERROR: No se puede calcular el CII antiguo si ninguno de los combustibles es el adecuado!",
           life: 1000,
         });
 
         //volvemos a poner los valores a 0 para mostrar que los hemos reseteado 
         this.oldAttainedCII = 0
         this.ship.oldAttainedCII = 0
       }
     },
 
     getFuelList(fuelList){
       this.fuelConsumptionArray = fuelList
     },
 
     save(){
       this.applyChangesToUser()
       this.applyChangesToShip()
       //Tenemos que guardar el barco y los datos del usuario cambiados
       //console.log("NeobuqFormEditShip-save - ship", this.ship);
       //console.log("NeobuqFormEditShip-save - user", this.user);
       var canSaveShip = true
 
       
       //comprobamos que están los datos que varían entre obligatorios-opcionales según las características del barco
       //si el barco es de alguno de estos tipos, debe meter el GT
       if(this.ship.shipType.code === "PSV" || this.ship.shipType.code === "RCS" || this.ship.shipType.code === "RPV"){
         if(this.ship.gt == null || this.ship.gt == undefined){
           this.showToast(false, "ERROR: ¡Debe introducir un valor para el GT!")
           canSaveShip = false;
         }
       }
 
       if(this.ship.iceClassType.code == "IC" || this.ship.iceClassType.code == "IB" || this.ship.iceClassType.code == "IA" || this.ship.iceClassType.code == "IA Super"){
 
         if((this.ship.lpp == null || this.ship.lpp == undefined) || (this.ship.displacementVolume == null || this.ship.displacementVolume == undefined) ||
             (this.ship.ds == null || this.ship.ds == undefined) || (this.ship.bs == null || this.ship.bs == undefined)){
 
           this.showToast(false, "ERROR: ¡Debe introducir TODOS los valores para el LPP, Vd, ds y Bs!")
           canSaveShip = false;
         }
       }
 
       if( (this.ship.keelLaidDownDate == null || this.ship.keelLaidDownDate == undefined) &&  (this.ship.shipDeliveredDate == null || this.ship.shipDeliveredDate == undefined) && 
           (this.ship.contractSignInDate == null || this.ship.contractSignInDate == undefined)){
           this.showToast(false, "ERROR: ¡Debe introducir al menos UNA fecha!")
           canSaveShip = false;
         }
       //console.log(this.ship.keelLaidDownDate)
 
       if(canSaveShip){
 
         const errorsInSave = this.shipService.saveShip(store.getters.currentShip);
         const userErrorsInSave = this.userService.saveUser(store.getters.currentUser, true);
 
         if (errorsInSave === "" || userErrorsInSave === "") {
           this.$toast.add({
             severity: ToastSeverity.SUCCESS,
             closable: false,
             summary: "Buque salvado correctamente",
             life: 1000,
           });
         } else {
           this.$toast.add({
             severity: "error",
             summary: "Error salvando el buque:" + errorsInSave,
             life: 5000,
           });
         }
 
       }else{
         this.showToast(false, "ERROR: Rellene los datos que faltan.")
       }
     },
 
     cancel(){
       //console.log("NeobuqFormEditShip-cancel", this.ship);
       this.shipService.selectedShip({});
       router.push({ name: "neobuqHome" });
     },
 
     //para mostrar mensajes de rellenar X campo o no
     showToast(successful, message) {
       if (successful) {
         this.$toast.add({
           severity: ToastSeverity.SUCCESS,
           closable: false,
           summary: message,
           life: 3000,
         });
       } else {
         this.$toast.add({
           severity: ToastSeverity.ERROR,
           closable: false,
           summary: message,
           life: 3000,
         });
       }
     },
   }
 };
 </script>
 
 <style scoped>
 .div1 {
   margin-top: 10px !important;
 }
 
 .div2 {
   padding: 2%;
 }
 
 .div4 {
   border-radius: 10px;
   border: 1px solid;
   padding: 2%;
   margin-bottom: 1%;
 }
 
 .final_elements {
   margin-top: 20px !important;
   padding: 20px 0px 0px 0px !important;
   margin-bottom: 80px !important;
   border: 2px solid black;
 }
 
 .crane_button {
   margin: 20px !important;
 }
 
 #btn {
   padding: 1.2%;
 }
 #inputField {
   width: 100%;
 }
 
 h2{
     padding-right: 90%;
 }
 
 .CII_value{
   display : inline; 
   border-style: solid;
 }
 
 .CII_paragraph{
   border-style: solid;
   border-width: thin;
   border-radius: 10px;
   padding : 20px;
 }
 
 #oldAttainedCII{
   border-style: solid;
   border-width: medium;
   border-radius: 3px;
   width: 200px;
   height: 50px;
   text-align: left;
   padding-left: 20px;
   padding-top: 12px;
 }
 
 
 </style>